import { render, staticRenderFns } from "./RecentActivityTableDescriptionAccountStatementSent.vue?vue&type=template&id=6d49077e&"
import script from "./RecentActivityTableDescriptionAccountStatementSent.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionAccountStatementSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports